import classNames from 'classnames';
import PropTypes from 'prop-types';

import { BorderedBox } from '../../BorderedBox';

import { CardCollection } from './cardCollection';
import { CardHeader } from './cardHeader';
import { useStyles } from './useStyles';

export const SelectionCard = ({
  imageUrl, user, title, collections, className
}) => {
  const classes = useStyles();

  const selections = collections.map(({
    // eslint-disable-next-line no-shadow
    title, textColor, bgColor, items
  }) => (
    <CardCollection
      key={title}
      title={title}
      textColor={textColor}
      bgColor={bgColor}
      items={items}
    />
  ));

  return (
    <BorderedBox className={classNames(classes.borderedBox, className)}>
      <CardHeader
        className={classes.headerGap}
        imageUrl={imageUrl}
        user={user}
        title={title}
      />
      {selections}
    </BorderedBox>
  );
};

SelectionCard.propTypes = {
  imageUrl: PropTypes.string,
  user: PropTypes.string,
  title: PropTypes.string,
  collections: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      textColor: PropTypes.oneOf(['focus00', 'focus90']),
      bgColor: PropTypes.string,
      items:    PropTypes.arrayOf(PropTypes.shape({
        text: PropTypes.string,
        textColor: PropTypes.oneOf(['focus00', 'focus90']),
        bgColor: PropTypes.string
      }))
    })
  )
};

SelectionCard.defaultProps = {
  imageUrl: '',
  user: 'User',
  title: 'Title',
  collections: []
};
